import Vue from 'vue';
import store from '@/store';
import initialize from '@/utils/initialize';
import AuthConfig from '@/utils/aws-exports';
import Auth from '@aws-amplify/auth';
import VueCookies from 'vue-cookies';
import VueIziToast from 'vue-izitoast';
import VueCryptojs from 'vue-cryptojs';
import VuetifyNumberInput from '@jzolago/vuetify-number-input';
import IdleVue from 'idle-vue';
import App from './App';
import vuetify from './plugins/vuetify';
import router from './router';
import '@/assets/css/tailwind.css';
import '@/assets/css/color/default.css';
import '@/assets/css/nprogress.css';
import '@/assets/css/style.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'izitoast/dist/css/iziToast.min.css';
import './plugins/vuetify-money';
import './plugins/vue-timeago';
import './registerServiceWorker';
import firebase from './services/firebase/firebase';

Vue.use(VuetifyNumberInput);

Vue.use(VueCryptojs);

Vue.use(VueIziToast, { position: 'topRight', timeout: 5000 });

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 300000, // 5 minutes
  startAtIdle: false,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
});

Vue.use(VueCookies);
Vue.$cookies.config('7d', null, null, true, 'Strict');

Auth.configure(AuthConfig);

initialize.init(router, store);

firebase.analytics();
Vue.prototype.$analytics = firebase.analytics();

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
